import {EventEmitter, Injectable} from '@angular/core';
import {SysConfigService} from './sys-config.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {EmployeeDTO} from '../dto/employee.model';
import {Observable} from 'rxjs/internal/Observable';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  employeeSearchDetailsChange = new EventEmitter<EmployeeDTO[]>();
  private employeeSearchDetailsItem: EmployeeDTO[] = [];


  private headers = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8'
  });

  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  public BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';

  /** Save Employee Details **/
  saveEmployeeDetails(employeeDto: EmployeeDTO){
    return this.httpClient.post(this.BASE_URL + 'employee/save' , employeeDto,{responseType: 'text'});
  }

  /** Search Employee Details **/
  getEmployeeDetails(employeeDto: EmployeeDTO): Observable<Object>{
    return this.httpClient.post(this.BASE_URL + 'employee/', employeeDto, { headers: this.headers });
  }

  /** get all Employee Details **/
  getAllEmployees(){
    return this.httpClient.get(this.BASE_URL + 'employee/all');
  }

  /** Delete Employee Details **/
  deleteEmployee(id: number) {
    return this.httpClient.delete(this.BASE_URL + 'employee/delete/'+ id,{headers: this.headers});
  }

  /** Check NIC is already Exist **/
  checkNICIfExist(nic: string) {
    return this.httpClient.get(this.BASE_URL + 'employee/checkNic/'+ nic,{headers: this.headers});
  }

  /** Check Email is already Exist **/
  checkEmailIfExist(email: string) {
    return this.httpClient.get(this.BASE_URL + 'employee/checkEmail/'+ email,{headers: this.headers});
  }

  /** reset searched details **/
  clearUserRoleSearchDetails() {
    this.employeeSearchDetailsItem = [];
    this.employeeSearchDetailsChange.emit(this.employeeSearchDetailsItem);
  }

  /** set search details in the table **/
  setUserRoleSearchDetails(employeeSearchDetails: EmployeeDTO[]) {
    console.log(employeeSearchDetails);
    this.employeeSearchDetailsItem = employeeSearchDetails;
    this.employeeSearchDetailsChange.emit(this.employeeSearchDetailsItem);
  }
}
